
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/destination-rules",
      function () {
        return require("private-next-pages/customer-studio/destination-rules.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/destination-rules"])
      });
    }
  